export default "__VITE_ASSET__b96a2e6a__"